import { mapOauthAuthorizeResponseDto } from 'modules/auth/domain/data-mappers/oauth-authorize.data-mapper';
import { OauthAuthorizeResponseDto } from 'modules/auth/domain/interfaces/oauth-authorize-response-dto';
import { restApi } from 'shared/api/rest-api';

/**
 * Согласие на доступ AI-клиента (MCP).
 *
 * `/oauth/authorize` у бэкенда вне `/api`, а `httpResource` клеит `baseURL: '/api'` к любому пути,
 * начинающемуся с `/`, — поэтому адрес абсолютный, от своего origin (на стенде nginx админки, локально
 * dev-прокси шлёт его на бэкенд). Строка запроса — как пришла (`search`), к ней только `consent=true`:
 * бэкенд сверяет `state` и `code_challenge` побайтно. Токен — общий заголовок `httpResource`,
 * его ставит `authCheck`.
 */
export const oauthApi = restApi.injectEndpoints({
  endpoints: (builder) => ({
    grantOauthConsent: builder.mutation<string, string>({
      query: (search) => ({ url: `${window.location.origin}/oauth/authorize${search}&consent=true` }),
      transformResponse: (dto: OauthAuthorizeResponseDto) => mapOauthAuthorizeResponseDto(dto),
    }),
  }),
});

export const { useGrantOauthConsentMutation } = oauthApi;
